import BannerHero from "@/components/bannerHero";
import ContactSection from "@/components/ContactArea";
import ServiceArea from "@/components/home/ServiceSection";
import Image from "next/image";
 
 
export default function Contact() {
  return (
    <>
     <BannerHero
                title="Contact Us"
                bgImage="/images/contact-bg1.png"
                className="contact" />
        <div className="shape-ellips">
               <Image src="/images/shape.png" alt="shape" fill className="position-relative"/>
             </div>
         <section className="contactService"><ServiceArea /></section>
      
     <ContactSection/>
    </>
  );
}
 
 